import { firebase } from '../firebase/firebase';
//Actions

const getPlacesFunction = firebase
  .functions()
  .httpsCallable('httpsDashboardGetPlaces');
const getPlaceUsersFunction = firebase
  .functions()
  .httpsCallable('httpsDashboardGetPlaceUsers');

export const getAdminPlaces = () => {
  return async () => getPlacesFunction();
};

export const getPlaceClans = (place, setClans) => {
  return async (dispatch) => {
    const clans = await firebase
      .database()
      .ref(`places/${place}/clans`)
      .once('value')
      .then((snap) => snap.val());
    return setClans ? dispatch(setPlaceClans(clans)) : clans;
  };
};

export const getPlace = (place) => {
  return (dispatch) => {
    const promises = [
      dispatch(getPlaceClans(place)),
      firebase.firestore().doc(`places/${place}`).get(),
      firebase.database().ref(`places/${place}/sites`).once('value'),
      dispatch(getPlaceUsers(place)),
    ];
    return Promise.all(promises).then((results) => {
      const data = {};
      data['clans'] = results[0];
      data['airtable'] = results[1].data().config.airtable;
      data['name'] = results[1].data().name;
      data['sites'] = results[2].val();
      data['uid'] = place;
      data['users'] = results[3].users;
      data['usersQueue'] = results[3].usersQueue;
      dispatch(setPlace(data));
    });
  };
};

export const getPlaceUsers = (place, setUsers) => {
  return async (dispatch) => {
    const placeUsers = await getPlaceUsersFunction({ place }).then(
      (res) => res.data
    );
    if (setUsers) {
      dispatch(setPlaceUsers(placeUsers.users));
      dispatch(setPlaceUsersQueue(placeUsers.usersQueue));
    } else {
      return placeUsers;
    }
  };
};

export const setPlace = (place) => ({
  type: 'SET_PLACE',
  place,
});

export const setPlaceClans = (clans) => ({
  type: 'SET_PLACE_CLANS',
  clans,
});

export const setPlaceName = (name) => ({
  type: 'SET_PLACE_NAME',
  name,
});

export const setPlaceUsersQueue = (usersQueue) => ({
  type: 'SET_PLACE_USERS_QUEUE',
  usersQueue,
});

export const setPlaceSites = (sites) => ({
  type: 'SET_PLACE_SITES',
  sites,
});

export const setPlaceUid = (placeUid) => ({
  type: 'SET_PLACE_UID',
  placeUid,
});

export const setPlaceUsers = (users) => ({
  type: 'SET_PLACE_USERS',
  users,
});
